import { createFileRoute } from "@tanstack/react-router";
import { GoalEditor } from "~/app/(new)/[teamId]/(with-student-nav)/students/[studentId]/goals/[goalId]/edit/GoalEditor";
import { trpc } from "~/utils/trpc.client";
import { useParams } from "~/components/navigation";
import Link from "~/components/Link";
import { PageLoading } from "~/components/PageLoading";
import { useState } from "react";
import { WithStudentNav } from "~/components/WithStudentNav";

export const Route = createFileRoute(
  "/_authed/$teamId/students/$studentId/goals/$goalId/edit",
)({
  component: StudentGoalEditPage,
});

function StudentGoalEditPage() {
  const params = useParams<{
    teamId: string;
    studentId: string;
    goalId: string;
  }>();

  const goal = trpc.goals.getGoal.useQuery({
    goalId: params.goalId,
  });
  const student = trpc.students.getStudent.useQuery({
    id: params.studentId,
  });

  const logStudentView = trpc.students.logStudentView.useMutation();
  // run this effect only once on mount
  useState(() => {
    logStudentView.mutate({
      studentId: params.studentId,
    });
  });

  if (!goal.data || !student.data) {
    return (
      <WithStudentNav>
        <PageLoading />
      </WithStudentNav>
    );
  }

  return (
    <WithStudentNav>
      <div className="m-auto flex w-full max-w-[1000px] flex-col gap-4 p-4">
        <div className="flex flex-row w-full">
          <div className="breadcrumbs text-sm overflow-visible">
            <ul>
              <li>
                <Link href={`/${params.teamId}`}>Team Home</Link>
              </li>
              <li>
                <Link href={`/${params.teamId}/students/${params.studentId}`}>
                  {student.data.name}
                </Link>
              </li>
              <li>
                <Link
                  href={`/${params.teamId}/students/${params.studentId}/goals`}
                >
                  Goals
                </Link>
              </li>
              <li>
                <span>Edit</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-2 mt-8">
          <div className="card bg-base-100 shadow">
            <div className="card-body">
              <div className="flex justify-between ">
                <h2 className="text-xl font-bold">Editing Goal</h2>
              </div>
              <GoalEditor goalId={goal.data.id} depth={0} />
            </div>
          </div>
        </div>
      </div>
    </WithStudentNav>
  );
}
